import script from "./OrderInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderInfo.vue?vue&type=script&lang=ts&setup=true"

import "./OrderInfo.vue?vue&type=style&index=0&id=4001ec94&scoped=true&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4001ec94"]])

export default __exports__